import { render, staticRenderFns } from "./BasketPresentation-gt3.vue?vue&type=template&id=54a02bc2&scoped=true"
import script from "./BasketPresentation-gt3.vue?vue&type=script&lang=js"
export * from "./BasketPresentation-gt3.vue?vue&type=script&lang=js"
import style0 from "./BasketPresentation-gt3.vue?vue&type=style&index=0&id=54a02bc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a02bc2",
  null
  
)

export default component.exports